import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import avatar1 from "../assets/images/avatar01.png";
import avatar2 from "../assets/images/avatar02.png";
import avatar3 from "../assets/images/avatar03.png";
import avatar4 from "../assets/images/avatar04.png";
import avatar5 from "../assets/images/avatar05.png";
import avatar6 from "../assets/images/avatar06.png";
import avatar7 from "../assets/images/avatar07.png";
import avatar8 from "../assets/images/avatar08.png";
import attendi from "../assets/images/attendi.png";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const avatarMap = {
    avatar01: avatar1,
    avatar02: avatar2,
    avatar03: avatar3,
    avatar04: avatar4,
    avatar05: avatar5,
    avatar06: avatar6,
    avatar07: avatar7,
    avatar08: avatar8,
};


const IpadAttesaSfidante = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { gameId, userId} = location.state || {};

    const [utenteInfo, setUtenteInfo] = useState({ avatar: '', nickname: '', npunti: 0 });
    const [isGameComplete, setIsGameComplete] = useState(false);



    // Recupera le informazioni dell'utente all'inizio
    useEffect(() => {
        fetch(`${API_BASE_URL}/api/utente/info`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userid: userId })  // Invia lo userid al backend
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Errore nel recupero delle informazioni utente');
                }
                return res.json();
            })
            .then((data) => {
                setUtenteInfo({ avatar: data.avatar, nickname: data.nickname, npunti: data.npunti });
            })
            .catch((error) => {
                console.error('Errore nel recupero delle informazioni utente:', error);
            });
    }, [userId]);

    // Polling per verificare se la partita è completata
    useEffect(() => {
        const interval = setInterval(() => {
            fetch(`${API_BASE_URL}/api/check-game-status?gameId=${gameId}`)
                .then((res) => res.json())
                .then((data) => {
                    if (data.isComplete) {
                        setIsGameComplete(true);
                        clearInterval(interval);
                    }
                });
        }, 2000); // ogni 2 secondi
        return () => clearInterval(interval);
    }, [gameId]);

    useEffect(() => {
        if (isGameComplete) {
            /*fetch(`${API_BASE_URL}/api/get-final-results`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ gameId, userId }),
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.hasWon) {
                        navigate('/ipad/haivinto', { state: { avatar: utenteInfo.avatar, nickname: utenteInfo.nickname, punteggio: utenteInfo.npunti } });
                    } else {
                        navigate('/ipad/haiperso', { state: { avatar: utenteInfo.avatar, nickname: utenteInfo.nickname, punteggio: utenteInfo.npunti } });
                    }});*/
            // devo solo andare alla pagina fine -> e mostrare sul monitor la classifica (chiamo monitorview?)


            navigate('/ipad/gameover', { state: { gameId, userId } });
        }
    }, [isGameComplete, navigate, gameId, userId, utenteInfo]);


    return (
        <div
            className="ipad_domanda_5 flex flex-col w-full h-full  items-center justify-center relative bg-fixed overflow-hidden">
           {/* <h1 className="text-3xl font-bold mb-8 text-center">Attendi la fine del gioco del tuo sfidante</h1>*/}


            <div className="fixed inset-0 flex items-center justify-center ">
                <div className="p-4 " style={{border: '0px solid red'}}>
                    {/* Spinner sopra l'immagine */}
                    <div className="spinner-overlay">
                        <div className="spinner"></div>
                    </div>
                    <img
                        src={attendi}
                        alt="Attendi ..."
                        className="cursor-pointer opacity-85"
                    />

                </div>

            </div>


            {/* Avatar e nickname in basso a sinistra */}
            <div className="absolute bottom-4 left-4 flex items-center space-x-4">
                <img src={avatarMap[utenteInfo.avatar]} alt="Avatar" className="w-12 h-12 rounded-full"/>
                <span className="text-2xl font-bold text-verde">{utenteInfo.nickname}</span>
            </div>

            {/* Punteggio in basso a destra */}
            <div className="absolute bottom-4 right-4 text-2xl font-bold text-verde">
                Your score: {utenteInfo.npunti}
            </div>

        </div>
    );
};

export default IpadAttesaSfidante;
